module["exports"] = ["### عمارة", "### طابق", "### شقة", "### بناية", "### بيت"];